import styled from 'styled-components'
import Button from '../Button'

export const Rows = styled.article`
  display: flex;
  flex-direction: column;
  width: 100%;
`
export const StyledButton = styled(Button)`
  margin-bottom: ${({ theme }) => theme.gutter};
`